import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CampaignsListComponent } from './campaigns-list/campaigns-list.component';
import { CampaignsDetailComponent } from './campaigns-detail/campaigns-detail.component';

const routes: Routes = [
  { path: "campaigns", component: CampaignsListComponent },
  { path: "campaigns/:id", component: CampaignsDetailComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CampaignsRoutingModule { }
